<template>
    <div class="container-fluid w-100" style="overflow: hidden">
        <div v-if="!newWorkAssignmentFor" class="nopads">
            <navbar v-if="!editMode" :title="$t('areas.equipment')"/>
            <!-- Equipment filter -->
            <area-equipment-filter
                :user="user"
                @search="fetchEquipment"
                class="my-2"
            />
            <!-- Equipment list -->
            <div class="col-sm-12 nopads">
                <span class="span-title result-info">{{ $t('common.results') }}: {{ results ? results.length : 0 }}</span>
                <equipment-list
                    :results="results"
                    @add="addEquipment"
                    @edit="editEquipment"
                    @newWorkAssignment="newWorkAssignment"
                />
            </div>
            <!-- Editor -->
            <base-modal v-if="editMode" size="lg" hide-footer hide-header @close="showEquipmentList">
                <equipment-editor
                    :equipment="equipment"
                    @close="showEquipmentList"
                    @closeAndUpdate="closeAndUpdate"
                />
            </base-modal>
        </div>
        <work-assignment-editor
            v-else
            :is-observer="isObserver"
            :area-equipment="newWorkAssignmentFor"
            @close="closeAssignmentEditor"
            @closeAndUpdate="closeAssignmentEditor"
        />
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import EquipmentList from './AreaEquipmentList'
import {areaHelper} from '../../mixins/AreaMixin'
import EquipmentEditor from './AreaEquipmentEditor'
import AreaEquipmentFilter from './AreaEquipmentFilter'
import WorkAssignmentEditor from "../../workassignment/WorkAssignmentEditor";
import Navbar from "@/components/utils/Navbar.vue";
import {inject} from "vue";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'AreaEquipment',
    components: {BaseModal, Navbar, WorkAssignmentEditor, EquipmentEditor, AreaEquipmentFilter, EquipmentList},
    mixins: [restApi, areaHelper],
    props: {
        user: {
            type: Object,
            default: null
        },
        isObserver: Boolean
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: true,
            error: false,
            editMode: false,
            equipment: null,
            results: [],
            lastSearchedParams: null,
            newWorkAssignmentFor: null
        }
    },
    mounted: function () {
        this.loading = false
    },
    methods: {
        fetchEquipment: function (params) {
            this.resetPage()
            this.loading = true
            this.lastSearchedParams = params
            this.restFetchParams(this.areaEquipmentUrl, this.lastSearchedParams, this.handleResponse, this.handleError)
        },

        resetPage: function () {
            this.error = false
            this.results = []
        },

        handleError: function (error) {
            this.loading = false
            if (error.response.status && error.response.status !== 200) {
                this.showAlert(this.$t('equipment.err_general'))
            }
        },

        handleResponse: function (response) {
            this.loading = false
            this.results = response.data
        },

        addEquipment: function () {
            this.equipment = this.newEquipment()
            this.editMode = true
        },

        editEquipment: function (item) {
            this.equipment = item
            this.editMode = true
        },

        showEquipmentList: function () {
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.showEquipmentList()
            this.fetchEquipment(this.lastSearchedParams)
        },

        newWorkAssignment(equipment) {
            this.newWorkAssignmentFor = equipment;
        },

        closeAssignmentEditor() {
            this.newWorkAssignmentFor = null;
        }
    }
}
</script>

<style scoped>
.result-info {
    margin-left: 1em;
    margin-bottom: 10px;
}
</style>
